import { useEffect } from "react";
import { Navigate, NavLink, Route, Routes, useMatch, useNavigate, useParams } from "react-router-dom";
import { useApp } from "./store";
import LoginGate from "./pages/LoginGate";
import HomePage from "./pages/HomePage";
import ListPage from "./pages/ListPage";
import SchoolModal from "./pages/SchoolModal";
import SettingsPage from "./pages/SettingsPage";
import PtPage from "./pages/PtPage";

// The site is a hub ("timtwhit") of small sub-apps that share one login: / is the menu,
// /rowing is the school finder, /pt is the PT externship list. A new sub-app = a new
// top-level <Route> here plus a card on HomePage. The menu itself needs the admin password.
export default function App() {
  const { ready, authed, admin } = useApp();
  const atMenu = useMatch("/");

  if (!ready) {
    return <div className="p-8 text-slate-500">Loading…</div>;
  }
  if (atMenu && !admin) {
    return <LoginGate adminOnly />;
  }
  if (!authed) {
    return <LoginGate />;
  }

  return (
    <Routes>
      <Route path="/" element={<Titled title="timtwhit"><HomePage /></Titled>} />
      <Route path="/rowing/*" element={<Titled title="Katie's Rowing School Finder"><RowingApp /></Titled>} />
      <Route path="/pt/*" element={<Titled title="Katie's PT Micro-Internship"><PtPage /></Titled>} />
      {/* Old pre-hub rowing URLs (bookmarks, shared links) */}
      <Route path="/settings" element={<Navigate to="/rowing/settings" replace />} />
      <Route path="/school/:id" element={<OldSchoolRedirect />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function Titled({ title, children }: { title: string; children: React.ReactNode }) {
  useEffect(() => {
    document.title = title;
  }, [title]);
  return <>{children}</>;
}

function OldSchoolRedirect() {
  const { id } = useParams();
  return <Navigate to={`/rowing/school/${id}`} replace />;
}

function RowingApp() {
  const tab = ({ isActive }: { isActive: boolean }) =>
    `px-3 py-2 text-sm rounded-md ${isActive ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-200"}`;

  return (
    <div className="mx-auto max-w-[1400px] p-3 sm:p-4">
      <header className="mb-4 flex flex-wrap items-center gap-x-3 gap-y-2">
        <h1 className="text-base font-bold sm:text-lg">
          Katie's Rowing <span className="hidden sm:inline">School Finder</span>
        </h1>
        <nav className="flex w-full gap-1 sm:ml-auto sm:w-auto">
          <NavLink to="/rowing" end className={tab}>
            All schools
          </NavLink>
          <NavLink to="/rowing/settings" className={tab}>
            Settings
          </NavLink>
        </nav>
      </header>

      <Routes>
        <Route path="settings" element={<SettingsPage />} />
        <Route path="*" element={<ListPage />} />
      </Routes>

      <SchoolModalHost />
    </div>
  );
}

function SchoolModalHost() {
  const match = useMatch("/rowing/school/:id");
  const navigate = useNavigate();
  if (!match?.params.id) return null;
  return <SchoolModal id={match.params.id} onClose={() => navigate("/rowing")} />;
}
